import axios from "axios";

const BASE_URL  = "https://rverdeadmin.klatus.systems";
const TOKEN_URL = `${BASE_URL}/api/v2/token/diagnostico/`;
const CACHE_KEY = "_gst";

async function fetchFreshToken() {
  const { data } = await axios.post(TOKEN_URL);
  const token = data.access ?? data.token ?? data.access_token ?? data.key;
  if (!token) throw new Error(`Token no encontrado en la respuesta: ${JSON.stringify(data)}`);
  sessionStorage.setItem(CACHE_KEY, token);
  return token;
}

export async function getGuestToken({ force = false } = {}) {
  if (!force) {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached && cached !== "undefined" && cached !== "null") return cached;
  }
  return fetchFreshToken();
}

export function createPublicApi(token) {
  const instance = axios.create({ baseURL: BASE_URL, timeout: 8000 });
  if (token) {
    instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    instance.defaults.headers.common["Content-Type"]  = "application/json";
  }
  // TODO: quitar antes de producción
  instance.interceptors.request.use((config) => {
    console.log("[publicApi] →", config.method?.toUpperCase(), config.url,
      "\n  Authorization:", config.headers?.Authorization ?? "(sin token)");
    return config;
  });
  return instance;
}
